import api from "./api";

class ParceiraAPI {
  async getCfg(headers) {
    return api.get("/cfg/parceira", { headers });
  }

  async salvarCfg(headers, params) {
    return api({
      method: "post",
      url: "/cfg/parceira",
      headers,
      data: params,
    });
  }

  async testarCfg(headers, params) {
    return api({
      method: "post",
      url: "/cfg/parceira/testar",
      headers,
      data: params,
    });
  }

  async removerCfg(headers, id) {
    return api({
      method: "delete",
      url: `/cfg/parceira/${id}`,
      headers,
    });
  }

  async minhasPessoasStatus(headers) {
    return api.get("/minhas-pessoas-status", { headers });
  }

  async replicarPessoa(headers, params) {
    return api({
      method: "post",
      url: "/replicar-pessoa",
      headers,
      data: params,
    });
  }

  async replicarPessoasLote(headers, params) {
    return api({
      method: "post",
      url: "/replicar-pessoas-lote",
      headers,
      data: params,
    });
  }

  async marcarExclusiva(headers, params) {
    return api({
      method: "post",
      url: "/marcar-exclusiva",
      headers,
      data: params,
    });
  }

  async marcarCompartilhada(headers, params) {
    return api({
      method: "post",
      url: "/marcar-compartilhada",
      headers,
      data: params,
    });
  }
}

export default new ParceiraAPI();
